export const BACKEND_FORMAT = 'yyyy-MM-ddTHH:mm:ss';
export const DATE_FORMAT = 'dd LLLL yyyy';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'yyyy.MM.dd HH:mm z';
